class WidgetService {
  async getSettings(appId, groupId) {
    // return fetch("https://api.ud4.ru/v2/wg/common-getSettings", {
      return fetch('https://api.sportpriority.com/v2/wg/common-getSettings', {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ appId, groupId }),
    }).then((response) =>
      response.ok ? response.json() : Promise.reject(response)
    );
  }
}

export default new WidgetService();
